import type { CSSProperties } from 'react';
import { useEffect, useRef } from 'react';

import type { WithHTMLProp } from '@/lib/types';

import * as S from './Overlay.styles';

export interface OverlayProps extends WithHTMLProp<'className'> {
  alignItems?: string;
  children: React.ReactNode;
  isFullWidthMobile?: boolean;
  isMobile?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
}

export const Overlay = ({
  alignItems,
  children,
  className,
  isFullWidthMobile = true,
  onClick,
  style,
}: OverlayProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleOnClick = (event: MouseEvent) => {
    if (overlayRef.current && event.target === overlayRef.current) {
      onClick?.(); //NOSONAR
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOnClick);

    return () => {
      document.removeEventListener('click', handleOnClick);
    };
  });

  return (
    <S.Wrapper
      ref={overlayRef}
      alignItems={alignItems}
      className={className}
      data-test-id='OverlayWrapper'
      isFullWidthMobile={isFullWidthMobile}
      style={style}
    >
      {children}
    </S.Wrapper>
  );
};

Overlay.displayName = 'Overlay';
